import { CONST } from '../lib/var/const';
import { isValidUriFormat } from '../util/valid';

// browser-safe path helpers
function extname(fname: string): string {
  const idx: number = fname.lastIndexOf('.');
  return idx >= 0 ? fname.slice(idx) : '';
}

function basename(fname: string, ext?: string): string {
  let base: string = fname;
  const slashIdx: number = base.lastIndexOf('/');
  if (slashIdx >= 0) base = base.slice(slashIdx + 1);
  const backslashIdx: number = base.lastIndexOf('\\');
  if (backslashIdx >= 0) base = base.slice(backslashIdx + 1);
  if (ext && base.endsWith(ext)) base = base.slice(0, -ext.length);
  return base;
}

function dirname(fname: string): string {
  const idx: number = Math.max(fname.lastIndexOf('/'), fname.lastIndexOf('\\'));
  return idx >= 0 ? fname.slice(0, idx) : '.';
}

function joinPath(a: string, b: string): string {
  if (a.endsWith('/') || a.endsWith('\\')) return a + b;
  return a + '/' + b;
}

export function buildURI(
  fileUri: string,
  uriFormat: string = 'filename',
  uriExt: boolean = false,
): string | undefined {
  let uri: string;
  if (!isValidUriFormat(uriFormat)) {
    console.warn('invalid uri format: ' + uriFormat);
    return;
  }
  if (uriFormat === CONST.URI.FNAME) {
    uri = '/' + basename(fileUri, CONST.EXTS.MD);
  }
  if (uriFormat === CONST.URI.RELPATH) {
    uri = fileUri.replace(process.cwd(), '');
  }
  if (uriFormat === CONST.URI.ABSPATH) {
    uri = fileUri;
  }
  // w/ file extension
  if (uriExt) {
    const slugifyUri: string = fileUri.trim().toLowerCase().replace(/ /g, '-');
    return slugifyUri;
  // w/o file extension
  } else {
    // @ts-expect-error: if-checks should prevent error
    const dir: string = dirname(uri);
    const fname: string = basename(fileUri, extname(fileUri));
    const fullUri: string = joinPath(dir, fname);
    const slugifyUri: string = fullUri.trim().toLowerCase().replace(/ /g, '-');
    return slugifyUri;
  }
}

export function extractFileName(
  uri: string,
  uriFormat: string = 'filename',
): string | undefined {
  if (!isValidUriFormat(uriFormat)) {
    console.warn('invalid uri format: ' + uriFormat);
    return;
  }
  return basename(uri, CONST.EXTS.MD);
}
